/*
 *  Binary Tree Data Structure: Node
 *  Implements a binary tree node.
 *
 *  Angular module: trackerbase-app.services.binary-tree.binary-tree-node
 *  Exposes: BinaryTreeNode
 */

class BinaryTreeNode {
    constructor(nodeData) {
        this._data = nodeData;
        this._parent = null;
        this._children = [ null, null ];
    }

    get leftChild() {
        return this._children[0];
    }

    set leftChild(childNode) {
        this._children[0] = childNode;
    }

    get rightChild() {
        return this._children[1];
    }
    set rightChild(childNode) {
        this._children[1] = childNode;
    }

    get parent() {
        return this._parent;
    }

    set parent(parentNode) {
        this._parent = parentNode;
    }

    get data() {
        return this._data;
    }

    set data(nodeData) {
        this._data = nodeData;
    }

    get childCount() {
        let cCount = this._children.filter(
            function(childEntry) {
                return (childEntry != null);
            }
        ).length;

        return cCount;
    }

    toString() {
        let leftChildStr = "null";
        let rightChildStr = "null";
        let dataStr = "null";
        if (this.leftChild != null) {
            leftChildStr = this.leftChild.toString();
        }
        if (this.rightChild != null) {
            rightChildStr = this.rightChild.toString();
        }
        if (this.data != null) {
            dataStr = this.data.toString();
        }
        let nodeStr = `\nBinaryTreeNode[[Data(${dataStr})_Left(${leftChildStr})_Right(${rightChildStr})]]\n`;
        return nodeStr;
    }

    prettyPrint(indentLevel,lineSep) {
        let indentStr = "&nbsp;&nbsp;&nbsp;&nbsp;".repeat(indentLevel);
        let leftChildStr = "null";
        let rightChildStr = "null";
        let dataStr = "null";
        if (this.leftChild != null) {
            leftChildStr = this.leftChild.prettyPrint(indentLevel + 1,lineSep);
        }
        if (this.rightChild != null) {
            rightChildStr = this.rightChild.prettyPrint(indentLevel + 1,lineSep);
        }
        if (this.data != null) {
            dataStr = this.data.toString();
        }
        let nodeStr = `${indentStr}BinaryTreeNode(${indentLevel}): Data(${dataStr})${lineSep}${indentStr}Left:${lineSep}${indentStr}${leftChildStr}${lineSep}${indentStr}Right:${lineSep}${indentStr}${rightChildStr}${lineSep}`;
        return nodeStr;
    }

    isLeaf() {
        return (this.childCount === 0);
    }

    isRoot() {
        return (this._parent == null);
    }
}

export default BinaryTreeNode;


//////////////////
// WEBPACK FOOTER
// ./src/services/binary-tree/BinaryTreeNode.js
// module id = Kf/0
// module chunks = 1